const API_URL = process.env.REACT_APP_API_URL;
const API_TOKEN = process.env.REACT_APP_API_TOKEN;

/**
 * Fire-and-forget event tracking
 * @param {string} event - "impression" | "view" | "contact"
 * @param {number|string} locationId
 */
export const trackEvent = (event, locationId) => {
    try {
        fetch(`${API_URL}/track`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Token': API_TOKEN
            },
            body: JSON.stringify({
                event,
                locationId,
                timestamp: new Date().toISOString()
            })
        }).catch(() => {});
    } catch (e) {
        // fire-and-forget
    }
};
